import { useCallback } from 'react';
import { useAdminFormContext } from '../components/AdminFormProvider';

export function useAdminFormData() {
  const { 
    formData, 
    updateField, 
    updateStepData, 
    getFieldError,
    clearValidationError 
  } = useAdminFormContext();

  // Handle single field updates
  const handleFieldChange = useCallback((field, value) => {
    updateField(field, value);
  }, [updateField]);

  // Handle multiple field updates
  const handleStepDataChange = useCallback((data) => {
    updateStepData(data);
  }, [updateStepData]);

  // Get field value with default
  const getFieldValue = useCallback((field, defaultValue = null) => {
    return formData[field] ?? defaultValue;
  }, [formData]);

  // Check if field has error
  const hasFieldError = useCallback((field) => {
    return !!getFieldError(field);
  }, [getFieldError]);

  // Clear field error
  const clearFieldError = useCallback((field) => {
    clearValidationError(field);
  }, [clearValidationError]);

  return {
    // Data
    formData,
    getFieldValue,
    
    // Field operations
    handleFieldChange,
    handleStepDataChange,
    
    // Validation
    hasFieldError,
    getFieldError,
    clearFieldError
  };
}